import { render, staticRenderFns } from "./ChoiceVariantTestSubsection.vue?vue&type=template&id=284d8d3c&scoped=true&"
import script from "./ChoiceVariantTestSubsection.vue?vue&type=script&lang=js&"
export * from "./ChoiceVariantTestSubsection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d8d3c",
  null
  
)

export default component.exports